import React from "react";
import {
  RequestActiveCallSocketVoz,
  ReturningCallback,
  returnListCallQueue,
  ShowInfoDisplay,
  RequestActiveCall,
} from "../actions";
import SelectRouteActiveCall from "./SelectRouteActiveCall/SelectRouteActiveCall";
import { connect } from "react-redux";
import {} from "../actions/websocket";
import { Popover } from "../actions/Tippy";
import { ReactComponent as FACEBOOKICON } from "../build/images/channels/facebook.svg";
import { ReactComponent as WHATSAPPICON } from "../build/images/channels/whatsapp.svg";
import { ReactComponent as VOZICON } from "../build/images/channels/voz-icon.svg";
import { ReactComponent as EMAILICON } from "../build/images/channels/email.svg";
import { ReactComponent as INSTAGRAMICON } from "../build/images/channels/instagram.svg";
import { ReactComponent as TELEGRAMICON } from "../build/images/channels/telegram.svg";
import { ReactComponent as TWITTERICON } from "../build/images/channels/twitter.svg";
import { ReactComponent as IconChannelAdd } from "../build/images/attendanceIcons/call-add.svg";

import { ReactComponent as VOZICONDISABLED } from "../build/new-midias-icons/voz.svg";
import { ReactComponent as WHATSAPPICONDISABLED } from "../build/new-midias-icons/whatsapp.svg";
import { ReactComponent as FACEBOOKICONDISABLED } from "../build/new-midias-icons/facebook.svg";
import { ReactComponent as INSTAGRAMDISABLED } from "../build/new-midias-icons/instagram.svg";
import { ReactComponent as EMAILICONDISABLED } from "../build/new-midias-icons/email.svg";
import { ReactComponent as TELEGRAMICONDISABLED } from "../build/new-midias-icons/telegram.svg";
import { ReactComponent as TWITTERICONDISABLED } from "../build/new-midias-icons/twitter.svg";
import { ReactComponent as LINKEDINICONDISABLED } from "../build/new-midias-icons/linkedin.svg";
import { ReactComponent as WEBCHATICONDISABLED } from "../build/new-midias-icons/webchat.svg";
import { ReactComponent as SMSICONDISABLED } from "../build/new-midias-icons/sms-icon.svg";
import { ReactComponent as TEAMSICONDISABLED } from "../build/new-midias-icons/teams.svg";
import Moment from "moment";

const { connection_platform } = require("../services/api");

const mapDispatchToProps = (dispatch) => {
  return {
    RequestActiveCallSocketVoz: (
      outband,
      infouser,
      trunk,
      mediaid,
      chamado,
      addtech,
      scriptrunk,
      operator,
      returning,
      queueid,
      recvcount,
      callback_count,
      tech,
      idgrupo_rota,
      idgrupo_transb,
      ipcurrent,
      cdrid,
      rotaencontrada
    ) => {
      dispatch(
        RequestActiveCallSocketVoz(
          outband,
          infouser,
          trunk,
          mediaid,
          chamado,
          addtech,
          scriptrunk,
          operator,
          returning,
          queueid,
          recvcount,
          callback_count,
          tech,
          idgrupo_rota,
          idgrupo_transb,
          ipcurrent,
          cdrid,
          rotaencontrada
        )
      );
    },
    ReturningCallbackIn: (
      queueid,
      inforetorno,
      recvcount,
      cdrid,
      mediaid,
      srvin,
      caller,
      called,
      cbackcount
    ) => {
      ReturningCallback(
        queueid,
        inforetorno,
        recvcount,
        cdrid,
        mediaid,
        srvin,
        caller,
        called
      )(dispatch);
      dispatch(returnListCallQueue("", queueid, "2", parseInt(cbackcount + 1)));
    },
    RequestActiveCall: (
      outband,
      infouser,
      trunk,
      mediaid,
      calledDigitado,
      addtech,
      scriptrunk,
      operator,
      returning,
      queueid,
      recvcount,
      cbackcount,
      idgrupo_transb,
      cdrold
    ) => {
      dispatch(
        RequestActiveCall(
          outband,
          infouser,
          trunk,
          mediaid,
          calledDigitado,
          addtech,
          scriptrunk,
          operator,
          returning,
          queueid,
          recvcount,
          cbackcount,
          idgrupo_transb,
          cdrold
        )
      );
    },
    ShowInfoDisplay: (post) => {
      dispatch(ShowInfoDisplay(post));
    },
  };
};

const mapStateToProps = (state) => {
  return {
    InfoUsers: state.informationusers,
    PermissionRouter: state.routergroups,
    OutBandService: state.outservices,
    StatusAgent: state.status,
    listCallQueue: state.listcallqueue,
    IPCurrent: state.ipcurrent,
    AtdSimult: state.atdsimult,
    ContactId: state.atendimento,
  };
};

class AddChannelCall extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      keyGen: "",
    };
  }

  SolicitarChamadaAtiva(
    e,
    permrouter,
    mediaid,
    outband,
    infouser,
    status,
    queue,
    number,
    AtdSimult,
    ipcurrent,
    statusAgent
  ) {
    if (this.props.ContactId.length !== 0) {
      localStorage.setItem(
        "current-service",
        this.props.ContactId.idatendimento
      );
    }
    if (statusAgent.allowCall === false) {
      this.props.InterationNotifier("Pausa não permite ativo", "permission");
      return true;
    }

    document.getElementById("simulation_click").click();

    if (permrouter != "undefined" && permrouter != "") {
      var existeRota = false;
      var rotaencontrada = false;
      var checkRota = false;
      var rotaDefault = false;
      var rotaAlternativa = false;
      var trunk = "";
      var addtech = "";
      var scriptrunk = "";
      var operator = "";
      var trunkDef = "";
      var addtechDef = "";
      var scriptrunkDef = "";
      var operatorDef = "";
      var tech = "";
      var techDef = "";
      var idgrupo_rota = "";
      var idgrupo_rotaDef = "";
      var idgrupo_transb = "";
      var idgrupo_transbDef = "";
      var chamado = number;
      var retorno = 0;
      var checkAtd = false;
      var tipochamada = 0;
      var dddValidado = "";

      if (mediaid === 5 || mediaid === 1 || mediaid === 8) {
        chamado = chamado.replace(/\D/g, "");
      }

      if (
        permrouter[0].areacodeid != "undefined" &&
        permrouter[0].areacodeid != ""
      ) {
        var DDD = permrouter[0].areacodeid;
        var DDDPadrao = permrouter[0].areacodeid;
      } else {
        var DDD = "";
        var DDDPadrao = "";
      }

      var calledDigitado = chamado;
      var valorfixo = [1, 2, 3, 4];
      var valormovel = [5, 6, 7, 8, 9];
      if (connection_platform.remove_digits || parseInt(mediaid) !== 1) {
        if (
          chamado[0] === "0" &&
          chamado.substr(0, 2) != "00" &&
          chamado.substr(0, 4) != "0800"
        ) {
          chamado = chamado.substr(1, chamado.length - 1);
        }
      }
      if (
        (chamado.length === 12 || chamado.length === 13) &&
        chamado.substr(0, 2) != "00"
      ) {
        if (
          chamado.substr(0, 2) === "55" &&
          (mediaid === 5 || mediaid === "5") &&
          chamado.length > 11
        ) {
          chamado = chamado.substr(2, chamado.length - 1);
          calledDigitado = calledDigitado.substr(2, calledDigitado.length - 1);
        }

        dddValidado = chamado.substr(2, 2);

        if (
          !connection_platform.remove_digits &&
          parseInt(mediaid) === 1 &&
          chamado.startsWith("0")
        ) {
          dddValidado = chamado.substr(1, 2);
        }

        if (parseInt(dddValidado) !== parseInt(DDDPadrao)) {
          if (valorfixo.indexOf(parseInt(chamado[4])) > -1) {
            if (mediaid == 1) tipochamada = 3;
            else if (mediaid == 5) tipochamada = 17;
            else if (mediaid == 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
            else if (mediaid === 11) tipochamada = 25;
          } else if (valormovel.indexOf(parseInt(chamado[4])) > -1) {
            if (mediaid == 1) tipochamada = 4;
            else if (mediaid == 5) tipochamada = 17;
            else if (mediaid == 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
            else if (mediaid === 11) tipochamada = 25;
          }
        } else if (parseInt(dddValidado) === parseInt(DDDPadrao)) {
          if (valorfixo.indexOf(parseInt(chamado[4])) > -1) {
            if (mediaid == 1) tipochamada = 1;
            else if (mediaid == 5) tipochamada = 17;
            else if (mediaid == 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
            else if (mediaid === 11) tipochamada = 25;
          } else if (valormovel.indexOf(parseInt(chamado[4])) > -1) {
            if (mediaid == 1) tipochamada = 2;
            else if (mediaid == 5) tipochamada = 17;
            else if (mediaid == 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
            else if (mediaid === 11) tipochamada = 25;
          }
        }
      }
      if (
        (chamado.length === 10 || chamado.length === 11) &&
        chamado.substr(0, 4) != "0800" &&
        chamado.substr(0, 2) != "00"
      ) {
        // DDD = chamado.substr(0, 2);
        // chamado = chamado.substr(2, chamado.length - 1);

        if (!connection_platform.remove_digits && chamado[0] === "0") {
          DDD = chamado.substr(1, 2);
          chamado = chamado.substr(3, chamado.length - 1);
        } else {
          DDD = chamado.substr(0, 2);
          chamado = chamado.substr(2, chamado.length - 1);
        }

        if (chamado.length === 8 && parseInt(chamado.substr(0, 1)) >= 6) {
          if (parseInt(chamado[0]) >= 6 && parseInt(chamado[0]) <= 9) {
            chamado = "9" + chamado;
          }
        }

        if (
          parseInt(parseInt(DDD)) != parseInt(DDDPadrao) &&
          chamado.substr(0, 2) != "00"
        ) {
          if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
            if (mediaid == 1) tipochamada = 3;
            else if (mediaid == 5) tipochamada = 17;
            else if (mediaid == 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
            else if (mediaid === 11) tipochamada = 25;
          } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
            if (mediaid == 1) tipochamada = 4;
            else if (mediaid == 5) tipochamada = 17;
            else if (mediaid == 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
            else if (mediaid === 11) tipochamada = 25;
          }
        } else if (parseInt(DDD) == parseInt(DDDPadrao)) {
          if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
            if (mediaid == 1) tipochamada = 1;
            else if (mediaid == 5) tipochamada = 17;
            else if (mediaid == 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
            else if (mediaid === 11) tipochamada = 25;
          } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
            if (mediaid == 1) tipochamada = 2;
            else if (mediaid == 5) tipochamada = 17;
            else if (mediaid == 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
            else if (mediaid === 11) tipochamada = 25;
          }
        }
        if (mediaid !== 8) {
          chamado = DDD + chamado;
        }
      } else if (chamado.length === 8 || chamado.length === 9) {
        if (chamado.length === 8 && parseInt(chamado.substr(0, 1)) >= 6) {
          if (parseInt(chamado[0]) >= 6 && parseInt(chamado[0]) <= 9) {
            chamado = "9" + chamado;
          }
        }

        if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
          if (mediaid == 1) tipochamada = 1;
          else if (mediaid == 5) tipochamada = 17;
          else if (mediaid == 8) tipochamada = 19;
          else if (mediaid === 4) tipochamada = 18;
          else if (mediaid === 6) tipochamada = 20;
          else if (mediaid === 9) tipochamada = 21;
          else if (mediaid === 10) tipochamada = 23;
          else if (mediaid === 3) tipochamada = 22;
          else if (mediaid === 2) tipochamada = 24;
          else if (mediaid === 11) tipochamada = 25;
        } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
          if (mediaid == 1) tipochamada = 2;
          else if (mediaid == 5) tipochamada = 17;
          else if (mediaid == 8) tipochamada = 19;
          else if (mediaid === 4) tipochamada = 18;
          else if (mediaid === 6) tipochamada = 20;
          else if (mediaid === 9) tipochamada = 21;
          else if (mediaid === 10) tipochamada = 23;
          else if (mediaid === 3) tipochamada = 22;
          else if (mediaid === 2) tipochamada = 24;
          else if (mediaid === 11) tipochamada = 25;
        }
        if (mediaid !== 1 && mediaid !== 8) {
          chamado = DDD + chamado;
          calledDigitado = DDD + calledDigitado;
        }
      } else if (chamado.substr(0, 4) == "0800" && chamado.length > 9) {
        //chamado = '0'+chamado;
        tipochamada = 8;
      } else if (chamado.substr(0, 2) == "00") {
        if (mediaid == 1) tipochamada = 5;
        else if (mediaid == 5) tipochamada = 17;
        else if (mediaid == 8) tipochamada = 19;
        else if (mediaid === 4) tipochamada = 18;
        else if (mediaid === 6) tipochamada = 20;
        else if (mediaid === 9) tipochamada = 21;
        else if (mediaid === 10) tipochamada = 23;
        else if (mediaid === 3) tipochamada = 22;
        else if (mediaid === 2) tipochamada = 24;
        else if (mediaid === 11) tipochamada = 25;
      } else {
        permrouter.map((result) => {
          if (result.calltypeid == 11) {
            if (
              parseInt(chamado) >= parseInt(result.partialnumber) &&
              parseInt(chamado) <= parseInt(result.partialnumber_end)
            ) {
              tipochamada = 11;
            }
          } else if (result.calltypeid == 6) {
            if (parseInt(chamado) === parseInt(result.partialnumber)) {
              tipochamada = 6;
            }
          }
        });
      }

      AtdSimult.map((atend) => {
        if (
          String(atend.telefone) === String(chamado) &&
          parseInt(mediaid) === parseInt(atend.idmidia)
        )
          checkAtd = true;
      });

      if (mediaid === 4) tipochamada = 18;
      else if (mediaid === 6) tipochamada = 20;
      else if (mediaid === 9) tipochamada = 21;
      else if (mediaid === 10) tipochamada = 23;
      else if (mediaid === 3) tipochamada = 22;
      else if (mediaid === 2) tipochamada = 24;
      else if (mediaid === 11) tipochamada = 25;

      if (checkAtd == false) {
        if (chamado != "") {
          if (!isNaN(chamado)) {
            this.setState({ senhaincorreta: "none" });

            permrouter.map((result) => {
              if (parseInt(result.idmidia) === parseInt(mediaid)) {
                if (parseInt(tipochamada) == result.calltypeid) {
                  if (parseInt(tipochamada) == 1) {
                    if (
                      (parseInt(chamado) >=
                        parseInt(result.areacode + result.partialnumber) &&
                        chamado <=
                          parseInt(
                            result.areacode + result.partialnumber_end
                          )) ||
                      parseInt(chamado) ==
                        parseInt(result.areacode + result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      (parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4)
                      ) >= parseInt(result.partialnumber) &&
                        chamado.substr(parseInt(chamado.length) - 8, 4) <=
                          parseInt(result.partialnumber_end)) ||
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4)
                      ) == parseInt(result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      result.operator !== null &&
                      result.operator != "" &&
                      result.areacode ===
                        parseInt(
                          chamado.substr(parseInt(chamado.length) - 10, 2)
                        )
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    } else if (rotaencontrada == false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) == 2) {
                    if (
                      (parseInt(chamado) >=
                        parseInt(result.areacode + result.partialnumber) &&
                        chamado <=
                          parseInt(
                            result.areacode + result.partialnumber_end
                          )) ||
                      parseInt(chamado) ==
                        parseInt(result.areacode + result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      (parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4)
                      ) >= parseInt(result.partialnumber) &&
                        chamado.substr(parseInt(chamado.length) - 8, 4) <=
                          parseInt(result.partialnumber_end)) ||
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4)
                      ) == parseInt(result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      result.operator !== null &&
                      result.operator != "" &&
                      result.areacode ===
                        parseInt(
                          chamado.substr(parseInt(chamado.length) - 11, 2)
                        )
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    } else if (rotaencontrada == false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) == 3) {
                    if (
                      (parseInt(chamado) >=
                        parseInt(result.areacode + result.partialnumber) &&
                        chamado <=
                          parseInt(
                            result.areacode + result.partialnumber_end
                          )) ||
                      parseInt(chamado) ==
                        parseInt(result.areacode + result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      (parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4)
                      ) >= parseInt(result.partialnumber) &&
                        chamado.substr(parseInt(chamado.length) - 8, 4) <=
                          parseInt(result.partialnumber_end)) ||
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4)
                      ) == parseInt(result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 10, 2)
                      ) == parseInt(result.areacode)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (rotaencontrada == false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) == 4) {
                    if (
                      (parseInt(chamado) >=
                        parseInt(result.areacode + result.partialnumber) &&
                        chamado <=
                          parseInt(
                            result.areacode + result.partialnumber_end
                          )) ||
                      parseInt(chamado) ==
                        parseInt(result.areacode + result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    } else if (
                      (parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4)
                      ) >= parseInt(result.partialnumber) &&
                        chamado.substr(parseInt(chamado.length) - 8, 4) <=
                          parseInt(result.partialnumber_end)) ||
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4)
                      ) == parseInt(result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 11, 2)
                      ) == parseInt(result.areacode)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (rotaencontrada == false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) == 5) {
                    if (rotaencontrada == false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) == 8) {
                    if (rotaencontrada == false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (
                    parseInt(tipochamada) != 5 &&
                    chamado.substr(0, 2) == "00" &&
                    parseInt(result.operator) == parseInt(chamado.substr(0, 2))
                  ) {
                    trunk = result.idtrunk;
                    addtech = result.addtech;
                    scriptrunk = result.scripttrunk;
                    operator = "";
                    tech = result.tech;
                    idgrupo_rota = result.idgrupo_rota;
                    idgrupo_transb = result.idgrupo_transb;
                    rotaencontrada = true;
                    existeRota = true;
                    checkRota = true;
                  } else if (parseInt(tipochamada) == 11) {
                    permrouter.map((result) => {
                      if (result.calltypeid == 11) {
                        if (
                          parseInt(chamado) >= parseInt(result.partialnumber) &&
                          parseInt(chamado) <=
                            parseInt(result.partialnumber_end)
                        ) {
                          trunk = result.idtrunk;
                          addtech = result.addtech;
                          scriptrunk = result.scripttrunk;
                          operator = "";
                          tech = result.tech;
                          idgrupo_rota = result.idgrupo_rota;
                          idgrupo_transb = result.idgrupo_transb;
                          rotaencontrada = true;
                          existeRota = true;
                          checkRota = true;
                        }
                      }
                    });
                  } else if (parseInt(tipochamada) == 6) {
                    permrouter.map((result) => {
                      if (result.calltypeid == 6) {
                        if (
                          parseInt(chamado) === parseInt(result.partialnumber)
                        ) {
                          trunk = result.idtrunk;
                          addtech = result.addtech;
                          scriptrunk = result.scripttrunk;
                          operator = "";
                          tech = result.tech;
                          idgrupo_rota = result.idgrupo_rota;
                          idgrupo_transb = result.idgrupo_transb;
                          rotaencontrada = true;
                          existeRota = true;
                          checkRota = true;
                        }
                      }
                    });
                  } else {
                    if (rotaencontrada == false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                    }
                  }
                }
              }
            });
            if (existeRota == true) {
              for (let i = 0; i < queue.length; i++) {
                var numberqueue = queue[i].caller;
                //if(chamado === numberqueue){
                if (numberqueue.search(chamado) !== -1) {
                  retorno = 1;
                  var queueid = queue[i].queueid;
                  var recvcount = queue[i].recv_count;
                  var cdrid = queue[i].cdrid;
                  var srvin = queue[i].serviceinid;
                  var caller = queue[i].caller;
                  var called = queue[i].called;
                  var cbackcount = queue[i].callback_count;
                  var status = queue[i].status;
                }
              }

              if (mediaid === 5) {
                chamado = chamado.toString();
                chamado = chamado.trim();
                calledDigitado = calledDigitado.toString();
                calledDigitado = calledDigitado.trim();
              }

              if (parseInt(mediaid) === 1) {
                if (retorno === 1) {
                  this.props.RequestActiveCallSocketVoz(
                    outband,
                    infouser,
                    trunk,
                    mediaid,
                    chamado,
                    addtech,
                    scriptrunk,
                    operator,
                    true,
                    queueid,
                    recvcount,
                    null,
                    tech,
                    idgrupo_rota,
                    idgrupo_transb,
                    ipcurrent,
                    cdrid,
                    checkRota
                  );
                  this.props.ReturningCallbackIn(
                    queueid,
                    true,
                    recvcount,
                    cdrid,
                    mediaid,
                    srvin,
                    caller,
                    called,
                    cbackcount,
                    status
                  );
                  this.props.ShowInfoDisplay("Clientes");
                } else {
                  this.props.RequestActiveCallSocketVoz(
                    outband,
                    infouser,
                    trunk,
                    mediaid,
                    chamado,
                    addtech,
                    scriptrunk,
                    operator,
                    false,
                    queueid,
                    recvcount,
                    null,
                    tech,
                    idgrupo_rota,
                    idgrupo_transb,
                    ipcurrent,
                    cdrid,
                    checkRota
                  );
                  this.props.ReturningCallbackIn(
                    queueid,
                    true,
                    recvcount,
                    cdrid,
                    mediaid,
                    srvin,
                    caller,
                    called,
                    cbackcount,
                    status
                  );
                  this.props.ShowInfoDisplay("Clientes");
                }
              } else {
                if (retorno === 1) {
                  this.props.RequestActiveCall(
                    outband,
                    infouser,
                    trunk,
                    mediaid,
                    calledDigitado,
                    addtech,
                    scriptrunk,
                    operator,
                    true,
                    queueid,
                    recvcount,
                    cbackcount,
                    idgrupo_transb,
                    cdrid
                  );
                  this.props.ReturningCallbackIn(
                    queueid,
                    true,
                    recvcount,
                    cdrid,
                    mediaid,
                    srvin,
                    caller,
                    called,
                    cbackcount,
                    status
                  );
                  this.props.ShowInfoDisplay("Clientes");
                } else {
                  this.props.RequestActiveCall(
                    outband,
                    infouser,
                    trunk,
                    mediaid,
                    calledDigitado,
                    addtech,
                    scriptrunk,
                    operator,
                    false,
                    queueid,
                    recvcount,
                    cbackcount,
                    idgrupo_transb
                  );
                  this.props.ShowInfoDisplay("Clientes");
                }
              }
              //this.props.ShowActiveCallIn('')
              //MicroModal.close('modal__falar-com-cliente');
              //this.numberToActive.value = '';
            } else {
              // this.setState({senhaincorreta: 'block'}) ;
              // document.getElementById('div_alert').innerHTML='Sem rota de sa&iacute;da!';
              this.props.InterationNotifier(
                "Sem rota de sa&iacute;da!",
                "call"
              );
            }
          } else {
            // this.setState({senhaincorreta: 'block'}) ;
            // document.getElementById('div_alert').innerHTML='Apenas n&uacute;meros!';
            this.props.InterationNotifier("Apenas n&uacute;meros!", "call");
          }
        } else {
          // this.setState({senhaincorreta: 'block'});
          // document.getElementById('div_alert').innerHTML='Informe o n&uacute;mero!';
          this.props.InterationNotifier("Informe o n&uacute;mero!", "call");
        }
      } else {
        this.props.InterationNotifier(
          "Este cliente já está sendo atendido por você",
          "call"
        );
      }
    }
  }

  renderPopover = (
    e,
    PermissionRouter,
    OutBandService,
    InfoUsers,
    StatusAgent,
    listCallQueue,
    AtdSimult,
    IPCurrent,
    voz,
    zap,
    face,
    ContactId,
    email,
    telegram,
    instagram
  ) =>
    (() => {
      if (ContactId.arrayChannels !== undefined) {
        if (ContactId.arrayChannels.length > 0) {
          return (
            <div className="context-menu" id="modal-contato-conferencia2">
              <ul className="context-menu__list">
                {ContactId.arrayChannels.map((array) => {
                  if (array.midiaid === 11 || array.midiaid === "11")
                    return null;
                  if (
                    (array.number !== ContactId.telefone &&
                      array.midiaid !== parseInt(ContactId.idmidia)) ||
                    (ContactId.telefone === array.number &&
                      array.midiaid !== parseInt(ContactId.idmidia))
                  ) {
                    if (array.number !== "" && array.number !== null) {
                      let className = "context-menu__item";
                      if (array.midiaid === 5 && !zap)
                        className =
                          "context-menu__item context-menu__item--disabled";
                      if (array.midiaid === 1 && !voz)
                        className =
                          "context-menu__item context-menu__item--disabled";
                      if (array.midiaid === 4 && !face)
                        className =
                          "context-menu__item context-menu__item--disabled";
                      if (array.midiaid === 3 && !email)
                        className =
                          "context-menu__item context-menu__item--disabled";
                      if (array.midiaid === 8 && !telegram)
                        className =
                          "context-menu__item context-menu__item--disabled";
                      if (array.midiaid === 6 && !instagram)
                        className =
                          "context-menu__item context-menu__item--disabled";

                      return (
                        <SelectRouteActiveCall
                          type="list"
                          midiaId={array.midiaid}
                          onChooseRoute={(event, selectedRoute) => {
                            this.SolicitarChamadaAtiva(
                              event,
                              selectedRoute,
                              array.midiaid,
                              OutBandService,
                              InfoUsers,
                              StatusAgent.status,
                              listCallQueue,
                              array.number,
                              AtdSimult,
                              IPCurrent,
                              StatusAgent
                            );
                          }}
                          numeroDoCliente={array.number}
                        />
                      );
                      return (
                        <li
                          className={className}
                          onClick={(event) =>
                            this.SolicitarChamadaAtiva(
                              event,
                              PermissionRouter,
                              array.midiaid,
                              OutBandService,
                              InfoUsers,
                              StatusAgent.status,
                              listCallQueue,
                              array.number,
                              AtdSimult,
                              IPCurrent,
                              StatusAgent
                            )
                          }
                        >
                          {array.midiaid === 5 && (
                            <a href="#" className="context-menu__link">
                              <WHATSAPPICON /> {array.number}
                            </a>
                          )}
                          {array.midiaid === 1 && (
                            <a href="#" className="context-menu__link">
                              <VOZICON /> {array.number}
                            </a>
                          )}
                          {array.midiaid === 4 && (
                            <a href="#" className="context-menu__link">
                              <FACEBOOKICON /> {array.number}
                            </a>
                          )}
                          {array.midiaid === 3 && (
                            <a href="#" className="context-menu__link">
                              <EMAILICON /> {array.number}
                            </a>
                          )}
                          {array.midiaid === 8 && (
                            <a href="#" className="context-menu__link">
                              <TELEGRAMICON /> {array.number}
                            </a>
                          )}
                          {array.midiaid === 6 && (
                            <a href="#" className="context-menu__link">
                              <INSTAGRAMICON /> {array.number}
                            </a>
                          )}
                        </li>
                      );
                    }
                  }
                })}
                {(() => {
                  let existVoz = false;
                  let existZap = false;
                  let existFace = false;
                  let existTelegram = false;
                  let existEmail = false;
                  let existInsta = false;
                  ContactId.arrayChannels.map((array) => {
                    if (array.midiaid === 1) existVoz = true;
                    else if (
                      array.midiaid === 3 &&
                      array.number !== "" &&
                      array.number !== null
                    )
                      existEmail = true;
                    else if (array.midiaid === 4) existFace = true;
                    else if (array.midiaid === 5) existZap = true;
                    else if (array.midiaid === 6) existInsta = true;
                    else if (array.midiaid === 8) existTelegram = true;
                  });

                  return (
                    <li className="context-menu__item context-menu__item--disabled">
                      {!existZap && (
                        <a href="#" className="context-menu__link">
                          <WHATSAPPICONDISABLED /> Indisponível
                        </a>
                      )}
                      {!existVoz && (
                        <a href="#" className="context-menu__link">
                          <VOZICONDISABLED /> Indisponível
                        </a>
                      )}
                      {!existFace && (
                        <a href="#" className="context-menu__link">
                          <FACEBOOKICONDISABLED /> Indisponível
                        </a>
                      )}
                      {!existEmail && (
                        <a href="#" className="context-menu__link">
                          <EMAILICONDISABLED /> Indisponível
                        </a>
                      )}
                      {!existTelegram && (
                        <a href="#" className="context-menu__link">
                          <TELEGRAMICONDISABLED /> Indisponível
                        </a>
                      )}
                      {!existInsta && (
                        <a href="#" className="context-menu__link">
                          <INSTAGRAMDISABLED /> Indisponível
                        </a>
                      )}
                    </li>
                  );
                })()}
              </ul>
            </div>
          );
        }
      }
    })();

  render() {
    const {
      InfoUsers,
      PermissionRouter,
      OutBandService,
      StatusAgent,
      listCallQueue,
      AtdSimult,
      IPCurrent,
      ContactId,
    } = this.props;

    var voz = false;
    var zap = false;
    var face = false;
    var email = false;
    var telegram = false;
    var instagram = false;

    if (InfoUsers.user_midias) {
      for (var i = 0; i < InfoUsers.user_midias.length; i++) {
        if (InfoUsers.user_midias[i] === 1) voz = true;

        if (InfoUsers.user_midias[i] === 5) zap = true;

        if (InfoUsers.user_midias[i] === 4) face = true;

        if (InfoUsers.user_midias[i] === 3) email = true;

        if (InfoUsers.user_midias[i] === 6) instagram = true;

        if (InfoUsers.user_midias[i] === 8) telegram = true;
      }
    }

    return (
      <Popover
        trigger="click"
        interactive={true}
        content={this.renderPopover(
          this,
          PermissionRouter,
          OutBandService,
          InfoUsers,
          StatusAgent,
          listCallQueue,
          AtdSimult,
          IPCurrent,
          voz,
          zap,
          face,
          ContactId,
          email,
          telegram,
          instagram
        )}
      >
        <button
          type="button"
          className="btn action with-icon with-dropdown tippy-popover tippy-context-menu tippy-active not-clicable-tooltip"
          data-tippy-placement="bottom"
          data-template="modal-contato-conferencia2"
          aria-describedby="tippy-19"
          id="chat-action-check-trocar-canal"
          data-tooltip="Adicionar Canal"
        >
          {/* <i className="material-icons">add_ic_call</i> */}
          <IconChannelAdd />
        </button>
      </Popover>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddChannelCall);
